export const customerSupportInfo = {
  internationalPhoneNumberDisplayFormat: '+1-212-520-8570',
  internationalPhoneNumber: '12125208570',
  domesticPhoneNumberDisplayFormat: '866-502-6384',
  domesticPhoneNumber: '18665026384',
  email: 'testadminsupport@collegeboard.org',
  contactLink: 'https://about.collegeboard.org/contact-us',
};
